<template>
  <div class="single-obituary-comment__threaded-comments">
    <div
      v-if="parent && hasThreadedComments"
      class="single-obituary-comment__threaded-comments-wrapper"
    >
      <template v-if="!showAllComments">
        <threaded-comments-single
          :comment="threadedComments[0]"
          :parent="parent"
          :attached="true"
        />

        <button
          v-if="threadedComments.length > 1"
          class="btn link single-obituary-comment__threaded-comments-toggle"
          @click.prevent="show"
        >
          <span v-text="texts.showAll" />

          <svg v-if="isMobile" class="icon icon--xsmall">
            <use href="#chevron-down" />
          </svg>
        </button>
      </template>

      <template v-else>
        <threaded-comments-list :list="threadedComments" :parent="parent" />
        <button
          v-if="isMobile"
          class="obituary-comments__input-button single-obituary-comment__threaded-comments-toggle"
          @click.prevent="create"
          v-text="texts.writeAComment"
        />
      </template>
    </div>

    <div
      v-else-if="parent && !hasThreadedComments"
      class="single-obituary-comment__threaded-comments-wrapper"
    >
      <button
        class="obituary-comments__input-button single-obituary-comment__threaded-comments-toggle"
        @click.prevent="create"
        v-text="texts.writeAComment"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { useScrollIntoView } from 'Composables/useScrollIntoView';
import { useThreadedComments } from '../composables/useThreadedComments';
import ThreadedCommentsList from './ThreadedComments/List.vue';
import ThreadedCommentsSingle from './ThreadedComments/Single.vue';

export default {
  name: 'SingleCommentThreadedComments',

  components: {
    ThreadedCommentsList,
    ThreadedCommentsSingle,
  },

  setup() {
    const {
      scrollIntoView,
      scrollIntoViewCentered,
      scrollIntoViewAlignBottom,
    } = useScrollIntoView();
    const { createdComments, hasCreatedComments, sort } = useThreadedComments();
    return {
      scrollIntoView,
      scrollIntoViewCentered,
      scrollIntoViewAlignBottom,
      createdComments,
      hasCreatedComments,
      sort,
    };
  },

  props: {
    parent: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      texts: lavendlaObituary.threadedComments,
    };
  },

  computed: {
    ...mapState('threadedComments', ['showAll']),
    ...mapGetters('global', ['isMobile']),

    hasThreadedComments() {
      return this.threadedComments && this.threadedComments.length;
    },

    hasMoreThenOneThreadedComment() {
      return this.hasThreadedComments && this.threadedComments.length > 1;
    },

    showMoreButton() {
      return this.hasMoreThenOneThreadedComment && !this.showAllComments;
    },

    showAllComments() {
      if (
        !this.hasMoreThenOneThreadedComment ||
        !this.isMobile ||
        !this.showAll ||
        !this.showAll.length
      ) {
        return false;
      }

      return !!this.showAll.some((id) => id === this.parent.id);
    },

    threadedComments() {
      if (!this.parent.children || !this.parent.children.length) {
        return [];
      }

      if (!this.hasCreatedComments) {
        return this.parent.children;
      }

      return this.sort(this.parent.children);
    },

    createdCommentsItem() {
      if (!this.hasCreatedComments) {
        return null;
      }

      const item = this.createdComments.filter(
        (storedItem) => storedItem.id === this.parent.id
      )[0];

      if (!item) {
        return null;
      }

      return item;
    },

    hash() {
      if (this.createdCommentsItem) {
        return this.createdCommentsItem.hash;
      }

      return '';
    },
  },
  mounted() {
    this.setParent(this.parent);
  },

  methods: {
    ...mapMutations('threadedComments', ['setParent', 'setShowAll']),
    ...mapActions('threadedComments', ['toggleModal']),

    show() {
      if (this.isMobile) {
        this.setShowAll(this.parent.id);
        this.scrollIntoViewCentered(
          '.single-obituary-comment__threaded-comments',
          `#comment-${this.parent.id}`
        );
        return;
      }

      this.setParent(this.parent);
      this.toggleModal('list');
    },

    create() {
      this.setParent(this.parent);
      this.toggleModal('create');
    },
  },
};
</script>
